import gql from 'graphql-tag'
import { projectFragment, projectSummaryFragment, projectSummaryFragmentShort } from "@/graphql/project/projectFragments";
import { tagFragment, customTagFragment, customTagLabelFragment } from '@/graphql/tag/tagFragments'
// import { userProfileFragment } from "@/graphql/user/userProfileFragments";
// import { customerFragment } from '@/graphql/customer/customerFragments'
// import { customerContactFragment } from '@/graphql/customer/customerContactFragments'
// import { customerLocationFragment } from '@/graphql/customer/customerLocationFragments'
import { projectShiftFragment, shiftFragment, draftShiftFragment } from "@/graphql/shift/shiftFragments";
import { projectAssignmentFragment, assignmentFragment, draftAssignmentFragment } from "@/graphql/assignment/assignmentFragments";
import { resourceFragment, resourceTypeFragment, staffVehiculeFragment } from "@/graphql/resource/resourceFragments";
// import { companyFragment } from '@/graphql/company/companyFragments'
import { categoryFragment } from "@/graphql/category/categoryFragments";

export const PROJECTINTERNALNOTES = gql`
    query projectInternalNotes(
        $projectID: ID!
    ){
        projectInternalNotes(
            id: $projectID
        ){
            id
            internal_notes
        }
    }
`
export const PROJECTFORMTEMPLATE = gql`
    query projectFormTemplate {
        projectFormTemplate{
            id
            name
            value
            position
            customTagLabel {
                ...customTagLabelFragment            
            }
        }
    }
    ${customTagLabelFragment}
`
export const PROJECTSSUMMARY = gql`
    query projects(
        $ids: [ID]
        $allProjects: Boolean
        $archivedProjects: Boolean
        $draftProjects: Boolean
        $confirmedProjects: Boolean
        $activeProjects: Boolean
        $projectManager: ID
        $status: ProjectStatus
        $moreFilters: MoreFiltersInput

        $dateRange: activeDuringInput
        $shiftsDateRange: activeDuringInputSingleDate!
        $page: Int
        $first: Int
        $orderBy: String = "name"
        $orderSort: SortOrder = DESC
    ){
        projects(
            ids: $ids
            allProjects: $allProjects
            archivedProjects: $archivedProjects
            draftProjects: $draftProjects
            confirmedProjects: $confirmedProjects
            activeProjects: $activeProjects
            projectManager: $projectManager
            status: $status
            dateRange: $dateRange
            moreFilters: $moreFilters
            page: $page
            first: $first
            orderBy:{
                field: $orderBy
                order: $orderSort
            }
        ){
            paginatorInfo{
                count
                perPage
                currentPage
                hasMorePages
            }
            data{
                ...projectSummaryFragment

                projectManager{
                    # ...userProfileFragment
                    id
                    name
                    email
                }
                supervisor{
                    # ...userProfileFragment
                    id
                    name
                    email
                }
                customers{
                    # ...customerFragment
                    id
                    name
                }
                projectCategories{
                    ...categoryFragment
                }
                contacts {
                    # ...customerContactFragment
                    id
                    name
                    email
                }
                locations {
                    # ...customerLocationFragment
                    id
                    name
                }

                prevShift(
                    dateRange: $shiftsDateRange
                )
                nextShift(
                    dateRange: $shiftsDateRange
                )
                customtags{
                    ...customTagFragment
                    label{
                        ...customTagLabelFragment
                    }
                }
                resources{
                    ...resourceFragment
                    type{
                        ...resourceTypeFragment
                    }
                }


                projectShifts {
                    ...projectShiftFragment
                    courses{
                        ...tagFragment
                    }
                    skills{
                        ...tagFragment
                    }
                    customtags{
                        ...customTagFragment
                        label{
                            ...customTagLabelFragment
                        }
                    }
                    resources{
                        ...resourceFragment
                        type{
                            ...resourceTypeFragment
                        }
                    }
                    staffVehicules{
                        ...staffVehiculeFragment
                        type{
                            ...resourceTypeFragment
                        }
                    }


                    projectAssignments{
                        ...projectAssignmentFragment
                        assignedTo{
                            # ...userProfileFragment
                            id
                            name
                            email
                            company{
                                id
                                categories{
                                    id
                                    color
                                }
                            }
                        }
                        profession{
                            ...tagFragment
                        }
                    }
                }
            }
        }
    }
    ${projectSummaryFragment}
    ${projectShiftFragment}
    ${tagFragment}
    ${customTagFragment}
    ${customTagLabelFragment}
    ${resourceFragment}
    ${staffVehiculeFragment}
    ${resourceTypeFragment}
    ${projectAssignmentFragment}
    ${categoryFragment}
`
export const PROJECTSSUMMARYSHORT = gql`
    query projects(
        $ids: [ID]
        $allProjects: Boolean
        $archivedProjects: Boolean
        $draftProjects: Boolean
        $confirmedProjects: Boolean
        $activeProjects: Boolean
        $projectManager: ID
        $status: ProjectStatus
        $moreFilters: MoreFiltersInput

        $dateRange: activeDuringInput
        $shiftsDateRange: activeDuringInputSingleDate!
        $page: Int
        $first: Int
    ){
        projects(
            ids: $ids
            allProjects: $allProjects
            archivedProjects: $archivedProjects
            draftProjects: $draftProjects
            confirmedProjects: $confirmedProjects
            activeProjects: $activeProjects
            projectManager: $projectManager
            status: $status
            dateRange: $dateRange
            moreFilters: $moreFilters
            page: $page
            first: $first
        ){
            paginatorInfo{
                count
                perPage
                currentPage
                hasMorePages
            }
            data{
                ...projectSummaryFragmentShort

                #projectManager{
                #    ...userProfileFragment
                #}
                #supervisor{
                #    ...userProfileFragment
                #}
                #customers{
                #    ...customerFragment
                #}
                #contacts {
                #    ...customerContactFragment
                #}
                #locations {
                #    ...customerLocationFragment
                #}

                #prevShift(
                #    dateRange: $shiftsDateRange
                #)
                #nextShift(
                #    dateRange: $shiftsDateRange
                #)
                #customtags{
                #    ...customTagFragment
                #    label{
                #        ...customTagLabelFragment
                #    }
                #}
                #resources{
                #    ...resourceFragment
                #    type{
                #        ...resourceTypeFragment
                #    }
                #}


                #projectShifts {
                #    ...projectShiftFragment
                #    courses{
                #        ...tagFragment
                #    }
                #    skills{
                #        ...tagFragment
                #    }
                #    customtags{
                #        ...customTagFragment
                #        label{
                #            ...customTagLabelFragment
                #        }
                #    }
                #    resources{
                #        ...resourceFragment
                #        type{
                #            ...resourceTypeFragment
                #        }
                #    }
                #    staffVehicules{
                #        ...staffVehiculeFragment
                #        type{
                #            ...resourceTypeFragment
                #        }
                #    }
#
#
                #    projectAssignments{
                #        ...projectAssignmentFragment
                #        assignedTo{
                #            ...userProfileFragment
                #        }
                #        profession{
                #            ...tagFragment
                #        }
                #    }
                #}
            }
        }
    }
    ${projectSummaryFragmentShort}
`

export const PROJECTS = gql`
    query projects(
        $ids: [ID]
        $allProjects: Boolean
        $archivedProjects: Boolean
        $draftProjects: Boolean
        $confirmedProjects: Boolean
        $activeProjects: Boolean
        $projectManager: ID
        $status: ProjectStatus
        $moreFilters: MoreFiltersInput

        $dateRange: activeDuringInput
        $shiftsDateRange: activeDuringInputSingleDate!
        $page: Int
        $first: Int
    ){
        projects(
            ids: $ids
            allProjects: $allProjects
            archivedProjects: $archivedProjects
            draftProjects: $draftProjects
            confirmedProjects: $confirmedProjects
            activeProjects: $activeProjects
            dateRange: $dateRange
            projectManager: $projectManager
            status: $status
            moreFilters: $moreFilters

            page: $page
            first: $first
        ){
            paginatorInfo{
                count
                perPage
                currentPage
                hasMorePages
            }
            data{
                ...projectFragment

                hasUnpublishedShift

                prevShift(
                    dateRange: $shiftsDateRange
                )
                nextShift(
                    dateRange: $shiftsDateRange
                )
                professions{
                    ...tagFragment
                }
                skills{
                    ...tagFragment
                }
                courses{
                    ...tagFragment
                }
                customtags{
                    ...customTagFragment
                    label{
                        ...customTagLabelFragment
                    }
                }
                resources{
                    ...resourceFragment
                    type{
                        ...resourceTypeFragment
                    }
                }

                projectManager{
                    # ...userProfileFragment
                    id
                    name
                    email
                }
                supervisor{
                    # ...userProfileFragment
                    id
                    name
                    email
                }
                customers{
                    # ...customerFragment
                    id
                    name
                }
                projectCategories{
                    ...categoryFragment
                }
                contacts {
                    # ...customerContactFragment
                    id
                    name
                    email
                }
                locations {
                    # ...customerLocationFragment
                    id
                    name
                }

                projectShifts {
                    ...projectShiftFragment
                    courses{
                        ...tagFragment
                    }
                    skills{
                        ...tagFragment
                    }
                    customtags{
                        ...customTagFragment
                        label{
                            ...customTagLabelFragment
                        }
                    }
                    resources{
                        ...resourceFragment
                        type{
                            ...resourceTypeFragment
                        }
                    }
                    staffVehicules{
                        ...staffVehiculeFragment
                        type{
                            ...resourceTypeFragment
                        }
                    }

                    projectAssignments{
                        ...projectAssignmentFragment
                        assignedTo{
                            # ...userProfileFragment
                            id
                            name
                            email
                            company{
                                id
                                categories{
                                    id
                                    color
                                }
                            }
                        }
                        profession{
                            ...tagFragment
                        }
                    }
                }

                shifts(
                    dateRange: $shiftsDateRange
                ) {
                    ...shiftFragment

                    assignments {
                        ...assignmentFragment
                        assignedTo {
                            # ...userProfileFragment
                            id
                            name
                            email
                            company{
                                id
                                categories{
                                    id
                                    color
                                }
                            }
                        }
                        accepted_by {
                            # ...userProfileFragment
                            id
                            name
                            email
                        }
                        profession{
                            ...tagFragment
                        }
                    }
                }

                draftShifts(
                    dateRange: $shiftsDateRange
                ) {
                    ...draftShiftFragment

                    assignments {
                        ...draftAssignmentFragment
                        assignedTo {
                            # ...userProfileFragment
                            id
                            name
                            email
                        }
                        profession{
                            ...tagFragment
                        }
                    }
                }


                created_by {
                    # ...userProfileFragment
                    id
                    name
                    email
                }
            }
        }
    }
    ${projectFragment}
    ${tagFragment}
    ${customTagFragment}
    ${customTagLabelFragment}
    ${resourceFragment}
    ${staffVehiculeFragment}
    ${resourceTypeFragment}
    ${projectShiftFragment}
    ${shiftFragment}
    ${draftShiftFragment}
    ${projectAssignmentFragment}
    ${assignmentFragment}
    ${draftAssignmentFragment}
    ${categoryFragment}
`
    // ${customerFragment}
    // ${customerContactFragment}
    // ${customerLocationFragment}

export const PROJECT = gql`
    query project(
        $id: ID!
        $shiftsDateRange: activeDuringInputSingleDate!
    ){
        project(
            id: $id
        ){
            ...projectFragment
            prevShift(
                dateRange: $shiftsDateRange
            )
            nextShift(
                dateRange: $shiftsDateRange
            )
            professions{
                ...tagFragment
            }
            skills{
                ...tagFragment
            }
            courses{
                ...tagFragment
            }
            customtags{
                ...customTagFragment
                label{
                    ...customTagLabelFragment
                }
            }
            resources{
                ...resourceFragment
                type{
                    ...resourceTypeFragment
                }
            }

            projectManager{
                # ...userProfileFragment
                id
                name
                email
            }
            supervisor{
                # ...userProfileFragment
                id
                name
                email
            }
            customers{
                # ...customerFragment
                id
                name
            }
            projectCategories{
                ...categoryFragment
            }
            contacts {
                # ...customerContactFragment
                id
                name
                email
            }
            locations {
                # ...customerLocationFragment
                id
                name
            }

            projectShifts {
                ...projectShiftFragment
                courses{
                    ...tagFragment
                }
                skills{
                    ...tagFragment
                }
                customtags{
                    ...customTagFragment
                    label{
                        ...customTagLabelFragment
                    }
                }
                resources{
                    ...resourceFragment
                    type{
                        ...resourceTypeFragment
                    }
                }
                staffVehicules{
                    ...staffVehiculeFragment
                    type{
                        ...resourceTypeFragment
                    }
                }


                projectAssignments{
                    ...projectAssignmentFragment
                    assignedTo{
                        # ...userProfileFragment
                        id
                        name
                        email
                    }
                    profession{
                        ...tagFragment
                    }
                }
            }

            shifts(
                dateRange: $shiftsDateRange
            ) {
                ...shiftFragment

                assignments {
                    ...assignmentFragment
                    assignedTo {
                        # ...userProfileFragment
                        id
                        name
                        email
                        company{
                            id
                            categories{
                                id
                                color
                            }
                        }
                    }
                    accepted_by {
                        # ...userProfileFragment
                        id
                        name
                        email
                    }
                    profession{
                        ...tagFragment
                    }
                }
            }

            draftShifts(
                dateRange: $shiftsDateRange
            ) {
                ...draftShiftFragment

                assignments {
                    ...draftAssignmentFragment
                    assignedTo {
                        # ...userProfileFragment
                        id
                        name
                        email
                    }
                    profession{
                        ...tagFragment
                    }
                }
            }


            created_by {
                # ...userProfileFragment
                id
                name
                email
            }
        }
    }
    ${projectFragment}
    ${tagFragment}
    ${customTagFragment}
    ${customTagLabelFragment}
    ${resourceFragment}
    ${staffVehiculeFragment}
    ${resourceTypeFragment}
    ${projectShiftFragment}
    ${shiftFragment}
    ${draftShiftFragment}
    ${projectAssignmentFragment}
    ${assignmentFragment}
    ${draftAssignmentFragment}
    ${categoryFragment}
`
    // ${customerFragment}
    // ${customerContactFragment}
    // ${customerLocationFragment}
    // ${userProfileFragment}
    
export const PROJECTFORM = gql`
    query project(
        $id: ID!
    ){
        project(
            id: $id
        ){
            ...projectFragment
            professions{
                ...tagFragment
            }
            skills{
                ...tagFragment
            }
            courses{
                ...tagFragment
            }
            customtags{
                ...customTagFragment
                label{
                    ...customTagLabelFragment
                }
            }
            resources{
                ...resourceFragment
                type{
                    ...resourceTypeFragment
                }
            }

            projectManager{
                # ...userProfileFragment
                id
                name
                email
            }
            supervisor{
                # ...userProfileFragment
                id
                name
                email
            }
            customers{
                # ...customerFragment
                id
                name
            }
            projectCategories{
                ...categoryFragment
            }
            contacts {
                # ...customerContactFragment
                id
                name
                email
            }
            locations {
                # ...customerLocationFragment
                id
                name
            }

            projectShifts {
                ...projectShiftFragment
                courses{
                    ...tagFragment
                }
                skills{
                    ...tagFragment
                }
                customtags{
                    ...customTagFragment
                    label{
                        ...customTagLabelFragment
                    }
                }
                resources{
                    ...resourceFragment
                    type{
                        ...resourceTypeFragment
                    }
                }
                staffVehicules{
                    ...staffVehiculeFragment
                    type{
                        ...resourceTypeFragment
                    }
                }


                projectAssignments{
                    ...projectAssignmentFragment
                    assignedTo{
                        # ...userProfileFragment
                        id
                        name
                        email
                    }
                    profession{
                        ...tagFragment
                    }
                }
            }

            created_by {
                # ...userProfileFragment
                id
                name
                email
            }
        }
    }
    ${projectFragment}
    ${tagFragment}
    ${customTagFragment}
    ${customTagLabelFragment}
    ${resourceFragment}
    ${staffVehiculeFragment}
    ${resourceTypeFragment}
    ${projectShiftFragment}
    ${projectAssignmentFragment}
    ${categoryFragment}
`
    // ${userProfileFragment}
    // ${customerFragment}
    // ${customerContactFragment}
    // ${customerLocationFragment}

export const PROJECTCARD = gql`
    query project(
        $id: ID!
        # $myAssignments: Boolean
        $projectShiftID: ID
    ){
        project(
            id: $id
        ){
            ...projectFragment
            customtags{
                ...customTagFragment
                label{
                    ...customTagLabelFragment
                }
            }
            resources{
                ...resourceFragment
                type{
                    ...resourceTypeFragment
                }
            }

            projectManager{
                # ...userProfileFragment
                id
                name
                email
                # company{
                #     ...companyFragment
                # }
            }
            supervisor{
                # ...userProfileFragment
                id
                name
                email
                # company{
                #     ...companyFragment
                # }
            }
            customers{
                # ...customerFragment
                id
                name
            }
            projectCategories{
                ...categoryFragment
            }
            contacts {
                # ...customerContactFragment
                id
                name
                email
                title
                customer{
                    # ...customerFragment
                    id
                    name
                }
            }
            locations {
                    # ...customerLocationFragment
                    id
                    name
                    street
                    town
                    state
                    country
                    zipcode
            }

            projectShifts(
                # myAssignments: $myAssignments
                projectShiftID: $projectShiftID
            ) {
                ...projectShiftFragment
                courses{
                    ...tagFragment
                }
                skills{
                    ...tagFragment
                }
                customtags{
                    ...customTagFragment
                    label{
                        ...customTagLabelFragment
                    }
                }
                resources{
                    ...resourceFragment
                    type{
                        ...resourceTypeFragment
                    }
                }
                staffVehicules{
                    ...staffVehiculeFragment
                    type{
                        ...resourceTypeFragment
                    }
                }


                projectAssignments{
                    ...projectAssignmentFragment
                    assignedTo{
                        # ...userProfileFragment
                        id
                        name
                        email
                        company{
                            id
                            categories{
                                id
                                color
                            }
                        }
                    }
                    profession{
                        ...tagFragment
                    }
                }
            }

            created_by {
                # ...userProfileFragment
                id
                name
                email
            }
        }
    }
    ${projectFragment}
    ${tagFragment}
    ${customTagFragment}
    ${customTagLabelFragment}
    ${resourceFragment}
    ${staffVehiculeFragment}
    ${resourceTypeFragment}
    ${projectShiftFragment}
    ${projectAssignmentFragment}
    ${categoryFragment}
`
    // ${userProfileFragment}
    // ${customerFragment}
    // ${customerContactFragment}
    // ${customerLocationFragment}
    // ${companyFragment}